import { css } from '@emotion/react';
import type {
  PromoteChannelRequest,
  Channel,
} from '@weave/schema-gen-ts/dist/schemas/integrations/sync-config-api/v1/message.pb';
import { ModalControlModalProps, Text } from '@frontend/design-system';
import { useAuth } from '../../../providers/auth.provider';
import { ActionModal, ActionModalContent } from '../shared/action-modal';

interface PromoteChannelModalProps {
  modalProps: ModalControlModalProps;
  sourceChannel?: Channel;
  targetChannelName?: string;
  isSaving?: boolean;
  onConfirm: (payload: PromoteChannelRequest) => void;
}

export const PromoteChannelModal = ({
  modalProps,
  sourceChannel,
  targetChannelName,
  isSaving,
  onConfirm,
}: PromoteChannelModalProps) => {
  const { user } = useAuth();

  const handleConfirm = () => {
    if (!sourceChannel || !targetChannelName) return;
    onConfirm({
      channelName: targetChannelName,
      promotedBy: user?.username ?? 'unknown',
      trainId: sourceChannel.currentTrainId,
    });
  };

  return (
    <ActionModal modalProps={modalProps} isSaving={isSaving}>
      <ActionModalContent
        title={
          <>
            Promote {sourceChannel?.channelName ?? ''} to {targetChannelName ?? ''}
          </>
        }
        onClose={modalProps.onClose}
        isSaving={isSaving}
        confirmLabel='Promote'
        savingLabel='Promoting…'
        confirmDisabled={!sourceChannel || !targetChannelName}
        onConfirm={handleConfirm}
      >
        {sourceChannel && targetChannelName && (
          <>
            <div css={summaryRowStyle}>
              <Text weight='bold'>Train Id :</Text>
              <Text>{sourceChannel.currentTrainId}</Text>
            </div>
            <div css={summaryRowStyle}>
              <Text weight='bold'>Target channel :</Text>
              <Text>{targetChannelName}</Text>
            </div>
          </>
        )}
      </ActionModalContent>
    </ActionModal>
  );
};

const summaryRowStyle = css`
  display: flex;
  gap: var(--fabric-space-gap-xs);
  align-items: baseline;
`;
